import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { useShallow } from 'zustand/react/shallow'

import { createExpiringStorage, DRAFT_TTL_MS } from 'utils/persistStorage'

const DEFAULT_STATE = {
  hsa_data: false,
  MMYT: {},
  vin: [],
  selections: [],
  attributes: [],
  equipments: [],
  photos: [],
  editvehicles: [],
  status: null,
}

export const useVehicleStore = create(
  persist(
    (set) => ({
      ...DEFAULT_STATE,

      setVehicleDetails: (payload) => {
        const { year, make, model, trim } = payload.attributes
        set({
          hsa_data: true,
          vin: payload?.input?.vin || {},
          MMYT: { year, make, model, trim },
          selections: payload?.selections || [],
          attributes: payload?.attributes || [],
          equipments: payload?.equipments || [],
          photos: payload?.photos || [],
          status: payload?.status,
        })
      },

      RemoveVehicleDetails: () => set({ ...DEFAULT_STATE }),

      AddEditVehicleDetails: (payload) => set({ editvehicles: payload || [] }),

      RemoveEditVehicleDetails: () => set({ editvehicles: [] }),
    }),
    {
      name: 'vehicleDetails',
      storage: createExpiringStorage(DRAFT_TTL_MS),
      // Non-sensitive draft fields only; store actions are never persisted.
      partialize: (state) => ({
        hsa_data: state.hsa_data,
        MMYT: state.MMYT,
        vin: state.vin,
        selections: state.selections,
        attributes: state.attributes,
        equipments: state.equipments,
        photos: state.photos,
        editvehicles: state.editvehicles,
        status: state.status,
      }),
    },
  ),
)

// Drop-in replacement for the retired VehicleContext's `useVehicle()` —
// returns the draft fields + actions (shallow-compared).
export const useVehicle = () =>
  useVehicleStore(
    useShallow((state) => ({
      hsa_data: state.hsa_data,
      MMYT: state.MMYT,
      vin: state.vin,
      selections: state.selections,
      attributes: state.attributes,
      equipments: state.equipments,
      photos: state.photos,
      editvehicles: state.editvehicles,
      status: state.status,
      setVehicleDetails: state.setVehicleDetails,
      RemoveVehicleDetails: state.RemoveVehicleDetails,
      AddEditVehicleDetails: state.AddEditVehicleDetails,
      RemoveEditVehicleDetails: state.RemoveEditVehicleDetails,
    })),
  )
